module.exports = __webpack_public_path__ + "img/joy.b71f917d.jpeg";